<template>
  <div class="interentsolutionMain">
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>行业痛点</li>
              </ul>
            </div>
            <div class="solutionList">
                <ul v-if="difficultList.length>0" >
                  <li v-for="(item,index) in difficultList" :key="index">
                      <div><img :src="item.img"></div>
                      <dl>
                        <dt>{{item.title}}</dt>
                        <dd>{{item.content}}</dd>
                      </dl>
                  </li>
                </ul>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConpor">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>解决方案</li>
                </ul>
              </div>
              <div class="programBox">
                  <div class="programBoxHead">
                    <div class="programItem">
                      <div class="programItemName">商户入驻</div>
                      <ul v-if="flowList.length>0" class="listTop">
                          <li v-for="(item,index) in flowList" :key="index">
                            <dl>
                              <dt><img :src="item.img"></dt>
                              <dd>{{item.name}}</dd>
                              <dd>{{item.content}}</dd>
                            </dl>
                          </li>
                      </ul> 
                      <p>全程司法通道服务：合同审查、律师咨询、鉴定公证、纠纷解决。</p>
                    </div>
                     <div class="programItem programItemb">
                       <div class="programItemName">用户购买相关服务</div>
                        <ul v-if="flowListx.length>0" class="listBottom">
                          <li v-for="(item,index) in flowListx" :key="index">
                            <dl>
                              <dt><span v-html="item.name"></span></dt>
                              <dd>{{item.content}}</dd>
                            </dl>
                          </li>
                        </ul> 
                     </div>
                     <div class="programItem programItemc">
                      <div class="programItemName ">会员自动续费</div>
                        <ul v-if="flowList.length>0">
                          <li v-for="(item,index) in flowLists" :key="index">
                            <dl>
                              <dt><span v-html="item.name"></span></dt>
                              <dd>{{item.content}}</dd>
                            </dl>
                          </li>
                        </ul> 
                      <p>全程提供纠纷在线解决司法通道服务：律师咨询、鉴定公证、纠纷解决。</p>
                    </div>
                  </div>
                  <div class="programBoxCon">
                      <p>
                                  随着传统行业互联网化的发展，各行各业都开始了互联网+的进程，出现了大量的互联网平台，连接商户与用户。电子签约平台可以为这些互联网平台提供缔结契约、合同签署的新方式，并通过基于智能合约的履约管控与关键业务流程数据的存证保全，保障平台、平台商户、平台用户的合法权益。
                      </p>
                      <p>
                              互联网平台解决方案提供实名认证、电子合同签署、履约管控、电子数据存证、在线公证、在线司法鉴定、律师咨询等多元化的在线服务。为互联网平台及其用户的权利义务保障提供支撑，从而提升其核心竞争力。
                        </p>
                  </div>
              </div>

            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConpor">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>适应场景</li>
                </ul>
              </div>
              <div class="adaptBox">
                <ul>
                  <li v-for='(item,index) in adaptList' :key='index'>
                    <img :src="item.img">
                    <span>{{item.name}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
           <div class="solttionConItem">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>特色保障</li>
                </ul>
              </div>
              <div class="guaranteeList">
                <ul>
                  <li v-for="(item,index) in guaranteeList" :key="index">
                    <div>
                        <img :src="item.img" class="BigImg">
                        <span class="icon" v-bind:style="{backgroundImage:'url(' + item.icon + ')'}"></span>
                    </div>
                    <dl>
                      <dt><span v-html="item.title"></span></dt>
                      <dd>{{item.content}}</dd>
                    </dl>
                  </li>
                </ul>
              </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      difficultList:[
        {
          img:require('../../../assets/images/solution/cbxld_icon.png'),
          title:'成本高效率低',
          content:'企业内部签署的合同数量逐年增长，导致了各类纸质文件需要专人管理，成本随之增长；且效率低下。'
        },
        {
          img:require("../../../assets/images/solution/offsite_icon.png"),
          title:"跨地域签署难",
          content:"绝大多数企业存在异地签署劳动合同的问题，跨地签署流程繁琐，耗时长。"
        },
        {
          img:require("../../../assets/images/solution/safe_icon.png"),
          title:"安全性差",
          content:"因其自身的特点，纸质文件存在易丢失、易损毁的特点，一旦文件被损毁或者丢失，将会造成严重的后果。"
        },
        {
          img:require("../../../assets/images/solution/zjlbq_icon.png"),
          title:"证据链不全",
          content:"纸质合同的签署，很难拿出完整的证据链，存在毁约风险。"
        },
      ],
      guaranteeList:[
        {
          img:require("../../../assets/images/solution/legal_img.png"),
          icon:require('../../../assets/images/solution/legal_nor_icon.png.png'),
          title:"法律效力",
          content:"对接公安部、工商局、银联数据库进行实名认证，保障合同主体可信，采用数字证书，可信时间源等方式，保障合同司法效力。"
        },
        {
          img:require("../../../assets/images/solution/Group 12.png"),
          icon:require('../../../assets/images/solution/znhy_nor_icon.png'),
          title:"智能合约履约",
          content:"通过履约条款，自动生成触发条件，写入区块链智能合约，进行履约管控，当满足触发条件时，合约自动执行。"
        },
        {
          img:require("../../../assets/images/solution/judicial_img.png"),
          icon:require('../../../assets/images/solution/judicial_nor_icon.png'),
          title:"司法保障",
          content:"司法联盟链同步至多家公证处、司法鉴定机构，仲裁机构以及互联网法院，多方参与共识，保证电子数据作为证据的司法证明能力。"
        },
        {
          img:require("../../../assets/images/solution/jbzx_img.png"),
          icon:require('../../../assets/images/solution/jdcb_nor_icon.png'),
          title:"降本增效",
          content:"减少线下签署环节，减少人力、邮寄、纸质合同及管理成本。达到大幅度提高人力资源管理工作的效率并降低成本的目的。"
        },
      ],
      flowList:[
        {
          img:require("../../../assets/images/solution/hzqt_icon1.png"),
          name:"合作洽谈",
          content:'洽谈并确认合作'
        },
        {
          img:require("../../../assets/images/solution/zcsm_icon1.png"),
          name:"注册实名",
          content:'确认服务协议，并进行申请人认证与企业认证'
        },
        {
          img:require("../../../assets/images/solution/scclbsh_icon1.png"),
          name:"上传材料并审核",
          content:'包括企业法人资料，申请人资料及其他行业资质'
        },
        {
          img:require("../../../assets/images/solution/shqy_icom1.png"),
          name:"商户签约",
          content:'申请人在线发起《入驻合同》并进行签署'
        },
        {
          img:require('../../../assets/images/solution/ptqs_icon1.png'),
          name:"平台签署",
          content:'互联网平台签署接口，自动完成合同签署'
        },
        {
          img:require('../../../assets/images/solution/bqpz_icon_nor1.png'),
          name:"存证保全",
          content:'将整个商户入驻全流程产生的数据存证上链，同步至司法联盟链'
        },
        {
          img:require('../../../assets/images/solution/scclbsh_icon1.png'),
          name:"上线发布",
          content:'商户将自己的商品服务或产品进行上传、审核通过后发布'
        },
      ],
      flowListx:[
       {
         name:"注册<br/>实名",
         content:'注册账号，同意服务协议，填写相关资料进行实名认证'
       },
       {
         name:"选定<br/>产品",
         content:'用户选定产品'
       },
       {
         name:"用户<br/>签署",
         content:'客户在线发起合同签署签订《XX服务合同》'
       },
       {
         name:"平台<br/>签署",
         content:'互联网平台调用签署接口，自动完成合同签署'
       },
       {
         name:"数据<br/>存证",
         content:'全证据链电子数据存证上链，同步至司法联盟链'
       },
       {
         name:"创建<br/>履约",
         content:'通过服务协议、合同内容，生成履约条款，写入智能合约'
       },
        {
         name:"自动<br/>执行",
         content:'根据职能合约写入的出发条件，满足时自动执行相应的计算机协议'
       },
       {
         name:'纠纷<br/>处理',
         content:'对于违约或者执行失败的合约，提供司法通道服务，进行在线纠纷解决'
       }
      ],
      flowLists:[
        {
          name:'协议<br>确定',
          content:'用户勾选同意平台会员自动续费协议'
        },
        {
          name:'意愿<br>确定',
          content:'通过登录密码、签约密码、短信核验等方式进行确认'
        },
        {
          name:'合同<br>签署',
          content:'通过合同在线签署、公众平台接口、私有化部署等方式进行签约'
        },
        {
          name:'数据<br>存证',
          content:'全证据链电子数据存证上链，同步至司法联盟链'
        },
        {
          name:'创建<br>履约',
          content:'根据履约条款，生成出发条件，写入智能合约'
        },
        {
          name:'自动<br>执行',
          content:'满足智能合约出发条件，自动执行会员自动续费协议'
        }
      ],
      adaptList:[
        {
          img:require('../../../assets/images/solution/wyc_icon.png'),
          name:'网约车'
        },
        {
          img:require('../../../assets/images/solution/zxjy_icon.png'),
          name:'在线教育'
        },
        {
          img:require('../../../assets/images/solution/zbpt_icon.png'),
          name:'直播平台'
        },
        {
          img:require('../../../assets/images/solution/zxaz_icon.png'),
          name:'在线安装'
        },
        {
          img:require('../../../assets/images/solution/dzsw_icon1.png'),
          name:'电子商务'
        },
        {
          img:require('../../../assets/images/solution/wgpt_icon.png'),
          name:'网购平台'
        },
      ]
    }
  }
}
</script>
<style lang="scss" >
.interentsolutionMain{
    width:100%;
    .solttionCon{
      .solttionConItem{
        width:1180px;
       padding-bottom:40px;
       margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
          }
        }
        .solutionList{
          width:100%;
          height: 190px;
          li{
            width: calc((100% - 60px) / 4);
            height: 190px;
            float: left;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            margin-right: 20px;
            padding:20px;
            box-sizing: border-box;
            border: 1px solid rgb(235,235,235);
            div{
              text-align: right;
              img{
                width:48px;
                height: auto;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-bottom: 10px;
              }
              dd{
                font-size: 13px;
                color: #787878;
                line-height: 19px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
             border-color: #fff;
          }
        }
        .programBox{
          width:100%;
          overflow: hidden;
          .programBoxHead{
            width: 100%;
            .programItem{
              width:100%;
              overflow: hidden;
              background: #FAFAFA;
              border: 1px dashed rgb(180,180,180);
               box-sizing: border-box;
               margin-bottom:30px;
              .programItemName{
                height: 40px;
                line-height: 40px;
                font-size: 18px;
                text-align: center;
                color: #646464;
                background: #F0F0F0;
                border-bottom: 1px dashed rgb(180,180,180);
                box-sizing: border-box;
              }
              p{
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                text-align: center;
                color: #646464;
                background: #FAFAFA;
                border-top: 1px dashed rgb(180,180,180);
              }
              ul{
                width:100%;
                display: block;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding:40px 20px 20px 20px;
                box-sizing: border-box;
                li{ 
                  text-align:center;
                  position: relative;
                  dl{
                  width: 130px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  flex-direction: column;
                    dt{
                     height: 40px;
                      display: flex;
                      justify-content:center;
                      border-radius: 50%;
                      align-items: center;
                      text-align: justify;
                      border-radius: 12px;
                      margin-bottom: 10px;
                      font-size: 16px;
                      letter-spacing: 2px;
                      img{
                        width: 30px;
                        height: auto;
                      }
                    }
                    dd:nth-child(2){
                      font-size: 18px;
                      color: #787878;
                      margin-bottom: 10px;
                    }
                    dd:nth-child(3){
                      font-size: 14px;
                        color: #969696;
                        line-height: 22px;
                        text-align: justify;
                    }
                  }
                }
                li:last-child:after{
                    background:none;
                  }
              }
              .listTop{
                  li:after{
                      content: '';
                      display: block;
                      position: absolute;
                      right: -47px;
                      top: 57px;
                      width: 61px;
                      height: 9px;
                      background:url("../../../assets/images/solution/shrz_line_img.png")no-repeat;
                      background-size:100% 100%;
                  }
                  li:nth-child(2):after{
                    right: -37px;
                  }
                  li:nth-child(3):after{
                    right: -62px;
                  }

              }
            }
            .programItemb{
              .listBottom{
                margin:0;
                li{
                  dl{
                    width:100px;
                    dt{
                      width: 60px;
                      height: 60px;
                      border: 2px dashed #505050;
                      span{
                        font-size: 16px;
                        color: #323232;
                        opacity: 0.8;
                        font-weight: bold;
                        font-family: 'PingFangSC-Semibold';
                      }
                    }
                    dd{
                      font-size: 14px!important;
                    color: #969696!important;
                    line-height: 22px;
                    text-align: justify;
                    margin:0 !important;
                    }
                  }
                }
                li:after{
                  content:'';
                  display: block;
                  position: absolute;
                  left:86px;
                  top: 27px;
                  width: 76px;
                  height: 9px;
                  background:url("../../../assets/images/solution/shrz_line_img.png")no-repeat;
                  background-size:100% 100%;
                }
                li:nth-child(7):after{
                   background: none;
                 }
                 li:nth-child(6):before{
                       content: '';
                        display: block;
                        position: absolute;
                        left: 51px;
                        top: -18px;
                        width: 309px;
                       height: 20px;
                      background:url("../../../assets/images/solution/wan.png")no-repeat;
                 }
                
              }
            }
            .programItemc{
              ul{
                li{
                  dl{
                    dt{
                      width:60px;
                      height: 60px;
                      background: #B41C2E;
                      border-radius: 12px;
                      margin:0 auto;
                      margin-bottom: 12px;
                      span{
                        opacity: 0.8;
                      font-family: 'PingFangSC-Semibold';
                      font-size: 16px;
                      color: #FFFFFF;
                      letter-spacing: 2px;
                      }
                    }
                    dd{
                      font-family: 'PingFangSC-Regular';
                      font-size: 14px!important;
                      color: #969696!important;
                      text-align: justify;
                      line-height: 22px;
                    }
                  }
                }
                li:after{
                  content: '';
                  display: block;
                  position: absolute;
                  width: 124px;
                  height: 15px;
                  top:23px;
                  right:-98px!important;
                  background: url("../../../assets/images/solution/hyzdxf_line_img.png")no-repeat;
                  background-size: 100% 100%;
                }
                
              }
            }
          }
          .programBoxCon{
            h1{
              width:100%;
              height: 60px;
              line-height: 60px;
              text-align: center;
              font-size: 18px;
              font-weight: normal;
              color: #787878;
              background: #EBEBEB;
              margin-bottom: 16px;
            }
            p{
              font-size: 14px;
              color:#787878;
              line-height: 26px;
              text-indent: 2em;
              text-align: justify;
              margin-bottom: 20px;
            }
          }
        }
        .solttionConpor{
          max-width: 1180px;
          margin:0 auto;
        }
        .guaranteeList{
          width:100%;
          height: 328px;
          li{
            width: calc((100% - 78px) / 4);
            height: 328px;
            float: left;
            margin-right: 26px;
            box-sizing: border-box;
            padding:2px;
            border: 1px solid rgb(235,235,235);
            div{
              width:100%;
              height: 160px;
              position: relative;
              .BigImg{
                width:100%;
                height: 100%;
              }
              .icon{  
                position: absolute;
                top:50%;
                left:50%;
                margin-top:-19px;
                margin-left: -20px;
                width:40px;
                height: 38px;
                background-size:100% 100%;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-top:11px;
                margin-bottom: 15px;
                text-align: center;
                span{
                  display: inline-block;
                  padding-bottom: 6px;
                  border-bottom: 2px solid #B4B4B4;
                }
              }
              dd{
                box-sizing: border-box;
                padding:0 16px;
                font-size: 14px;
                color: #787878;
                line-height: 21px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
            border-color: #fff;
            dl dt span{
              border-color:#686868;
            }
          }
          li:nth-child(1):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/legal_hov_icon.png')!important;
            }
          }
          li:nth-child(2):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/znhy_hov_icon.png')!important;
            }
          }
          li:nth-child(3):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/judicial_hov_icon.png.png')!important;
            }
          }
          li:nth-child(4):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/jdcb_hov.png')!important;
            }
          }
        }
        .adaptBox{
          width:100%;
          height: 200px;
          border: 2px dashed #DCDCDC;
          display: flex;
          align-items: center;
          ul{
            display: flex;
            justify-content:space-between;
            align-items: center;
            width:100%;
            padding:0 104px;
            box-sizing:border-box;
            li{
              display: flex;
              justify-content:center;
              align-items: center;
              flex-direction: column;
              position: relative;
              img{
                width:60px;
                line-height: 60px;
              }
              span{
                margin-top: 10px;
                font-size: 18px;
                color: #000000;
                text-align: center;
                line-height: 18px;
              }
            }
            li:after{
              content: '';
              display: block;
              position: absolute;
              right: -118px;
              top: 29px;
              width: 124px;
              height: 4px;
              background:url("../../../assets/images/solution/line_c.png")no-repeat;
              background-size:100% 100%;
            }
            li:nth-child(1):before{
              content: '';
              display: block;
              position: absolute;
              left: -62px;
              top: 29px;
              width: 62px;
              height: 4px;
              background:url("../../../assets/images/solution/line_c.png")no-repeat;
              background-size:100% 100%;
            }
            li:nth-child(1):after{
              width:118px;
            }
            li:last-child:after{
              width:62px;
              right: -56px;
            }
          }
        }
      }
      .solttionConItem:nth-child(2){
        width: 100%;
        background: #F3F2F2;
      }
    }
  }
</style>
